import {
    onAdShow,
    fetchInitData,
    readyToShowAD,
    failureToShowAD,
    broadcast,
    onBroadcast,
} from "../../api";
import {getAppFlyerRoute, getUrlParams} from '../../common/util'
import Template from "../component/template/Template";
import Unit from "../Unit";
import Webview from "../component/native/visible/Webview";
import App from "../App";
import Message from "../FrameMessage";
// import jsBridge from "../../common/jsBridge";

// 直接注册onAdShow可能会因注册时机过晚而遗漏（webviewshow已触发之后再注册的情况），
// 所以添加该方法在已触发webviewshow之后注册仍可响应到webviewshow事件
const whenAdShow = (function () {
    let cbCatch = []
    let isShowed = false
    let result = null
    console.log('webviewshow之前',location.href)

    function fire (res, from) {
        console.log('... webviewshow',cbCatch, from, location.href)
        cbCatch.forEach(item => {
            item(res)
        })
        cbCatch = []
    }

    (function(){
        let called = false
        onAdShow((data) => {
            if(called===false) {
                console.log('--onAdShow ============>', data, location.href)
                App.broadcast('MTG_AdShow', data)
                called = true

                console.log('... webviewshow',cbCatch, location.href)
                isShowed = true
                result = data
            }
        })
    })()

    //监听从父window视图发来的webviewshow
    window.addEventListener('message', (e)=>{
        const {action, data} = e.data
        if(action==='webviewshow'){
            console.log("iframe ... MTG_AdShow webviewshow====>",e, location.href)
            ///fireEvent('webviewshow', data)
            fire(data, 'addEventListener')
        }
    })
    
    onBroadcast('MTG_AdShow',(event) => {
        console.log('... 接收到广播 MTG_AdShow',location.href)
        const { data } = event
        fire(data, 'onBroadcast')
    })

    return function (cb) {
        if (isShowed) {
            cb(result)
        } else {
            cbCatch.push(cb)
        }
    }
})()


class BaseLoader {
    constructor() {
        this.rootViewId = undefined
        this.rootView = null
        this.rootWebviewId = undefined
        this.rootWebview = null
        this.unit = null
        this.initData = null
        this.templateClass = function () {}
    }

    getRootViewId() {
        return this.rootViewId
    }

    getRootView() {
        return this.rootView
    }

    getRootWebviewId() {
        return this.rootWebviewId
    }

    getRootWebview() {
        return this.rootWebview
    }

    getUnit() {
        return this.unit
    }

    getInitData() {
        return this.initData
    }

    initRootView(data = {}) {
        let rootWebviewId = data.sdkSetting.instanceId || 1
        let rootViewId = data.sdkSetting.rootViewInstanceId || 1
        if (this.rootViewId !== rootViewId) {
            this.rootViewId = rootViewId
            this.rootView = {id: this.rootViewId}
        }
        if (this.rootWebviewId !== rootWebviewId) {
            this.rootWebviewId = rootWebviewId
            this.rootWebview = new Webview({id: this.rootWebviewId})
        }
    }

    fetchDataSource(fetchFun) {
        const query = getUrlParams()
        console.log('createByIframe=====>', location.href, query.createByIframe, query.createByIframe === 'true')
        if(query.createByIframe === 'true'){
            let timeoutTimer = undefined
            const ret =  Promise.race([
                new Promise((resolve, reject) => {
                    window.addEventListener('message', (e)=>{
                        console.log("iframe 获取到 message====>",e, location.href)
                        const {action, data} = e.data
                        if(action==='initData'){
                            resolve(data)
                        }
                    })
                }), new Promise((resolve, reject) => {
                    timeoutTimer = setTimeout(()=>{
                        reject('init time out')
                    },25e3)
                })
            ])
            ret.then((res)=>{
                console.log('createByIframe.fetchDataSource',res)
                clearTimeout(timeoutTimer)
            }).catch(res=>{
                console.log('createByIframe.fetchDataSource err',res)
            })
            return ret
        }else{
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await fetchFun({
                        h5cbp:1
                    })
                    console.log("h5cbp",1)
                    /*
                    const { code, data={} } = res
                    if(code === 0){
                        resolve(data)
                    }else {
                        reject(new Errow('初始化数据失败'))
                    }
                    */
                    resolve(res)
                } catch (e) {
                    console.warn('初始化数据失败, 请确认当前环境为 mintegral SDK', e)
                    reject(e)
                }
            })
        }
        
    }

    addAdShowListener(cb) {
        console.log('... sbd 注册 onAdShow', location.href)
        whenAdShow((data) => {
            console.log('... 接收到 onAdShow',location.href)
            setTimeout(() => {
                cb(data)
            }, 0)

        })
        /*onBroadcast('MTG_AdShow',(event) => {
            console.log('接收到广播 MTG_AdShow')
            const { data } = event
            cb(data)
        })*/
    }

    createTemplate(campaignList, unit) {
        throw new Error('BaseLoader.createTemplate为抽象方法，需要子类覆盖实现')
    }

    loadTemplate(templateClass, cb, fetchFun = fetchInitData) {
        console.log('tpl.loadTemplate ============>')
        return new Promise((resolve, reject) => {
            if (!templateClass) {
                reject('初始化参数错误，未指定相应模板')
            }/*else if (! templateClass instanceof Template){
                reject('模板初始化参数错误')
            }*/
            this.templateClass = templateClass
            this.fetchDataSource(fetchFun).then((data) => {
                console.log('fetchDataSource init ============>', data, location.href)
                getAppFlyerRoute();
                this.initData = data
                window.initData = data
                this.initRootView(data)
                const {campaignList, unitSetting} = data
                const unitId = unitSetting.unitId
                console.log('tpl.createUnit ============>', unitId, unitSetting, this)
                const unit = new Unit(unitId, unitSetting)
                this.unit = unit
                cb && (typeof cb === 'function') && cb(data)
                console.log('tpl.createTemplate ============>')
                const tpl = this.createTemplate(campaignList, unit)
                unit.setTemplate(tpl)

                console.log('... tpl.addAdShowListener ============>', location.href)
                this.addAdShowListener((res) => {
                    console.error('... 大模版收到 addAdShowListener onAdShow ============>', location.href)
                    tpl.adShowed(res)
                })
                // tpl.whenLoad().then(() => {
                //     console.log('tpl.whenLoad ============>')
                //     //this.readyToShowAD()
                // }).catch(() => {
                //     console.log('tpl.whenLoad err============>')
                //     //this.failureToShowAD()
                // })
                tpl.whenLoad().then(()=>{
                    // console.error('发送 tpl.whenLoad ============>1', this, this.rootWebviewId)
                    Message.emitMessageToSuperView('templateLoadFinish', {
                        id: this.rootWebviewId
                    })
                }).catch((err)=>{
                    console.error('发送 Error tpl.whenLoad ============>1',err)
                    Message.emitMessageToSuperView('templateLoadFailure', {
                        id: this.rootWebviewId
                    })
                })
                resolve({data, tpl, unit})
            }).catch(e => {
                console.error('promise catch an error:', e)
                reject(e)
            })
        })
    }
}

export default BaseLoader